module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("“THAT’S GOOD, HONEY")]), _vm._v("-pie. You look just fine now, all cleaned up and smellin’ sweet. Sit down here and I’ll go get your young man.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The soldier slumps on the edge of the bed and stares at the hands quaking in her lap. White and puffy. Underwater hands.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What young man?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Something beeps in a corner. The ceiling light glares. White everywhere: The raised bed. The window blinds. The walls and the floor and the ceiling. Her swollen feet. Shivering hands.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A giant clock face on the TV ticks one second. Two.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Katie?” A tall man steps into the room.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The soldier flinches.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Don’t be scared. It’s only me.” The man’s voice wobbles.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The soldier scoots to the far side of the bed, pulls her self to her feet and backs up against the wall. Only then does she really look at him. The man is pale and young and long-haired.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You do know who I am, don’t you?” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The man seems to be crying.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-756ac817","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781569479674_Split11.vue
// module id = 90
// module chunks = 0